// WGL: keeps the .sale_percent badge in sync with the selected variant.
//
// Prestige's own live-update elements (<sale-price>, <compare-at-price>, <on-sale-badge> --
// see assets/theme.js, OnSaleBadge) listen for the "variant:change" CustomEvent dispatched on
// the product <form> by VariantPicker.selectVariant, and update themselves in
// connectedCallback/disconnectedCallback. This element ports that exact mechanism onto the
// plain .sale_percent badge, which previously had no such wiring and froze at whichever
// variant was first rendered server-side.
//
// This file ships unbundled (no build step), so it intentionally avoids native `#private`
// class fields: theme.js's compiled output transpiles private fields down to WeakMap-based
// helpers for its target browsers, which means that syntax isn't safe to hand-write here as-is.
// A constructor-bound method (mirroring OnSaleBadge's actual runtime shape once bundled) gets
// the same encapsulation without relying on syntax this bundle avoids.
class WglSalePercent extends HTMLElement {
  constructor() {
    super();
    this.onVariantChanged = this.onVariantChanged.bind(this);
  }

  onVariantChanged(event) {
    const variant = event.detail && event.detail.variant;
    if (!variant || !(variant.compare_at_price > variant.price)) {
      this.hidden = true;
      return;
    }
    this.textContent = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + "%";
    this.hidden = false;
  }

  connectedCallback() {
    const form = document.forms[this.getAttribute("form")];
    if (form) {
      form.addEventListener("variant:change", this.onVariantChanged);
    }
  }

  disconnectedCallback() {
    const form = document.forms[this.getAttribute("form")];
    if (form) {
      form.removeEventListener("variant:change", this.onVariantChanged);
    }
  }
}

if (!window.customElements.get("wgl-sale-percent")) {
  window.customElements.define("wgl-sale-percent", WglSalePercent);
}
